import { render, staticRenderFns } from "./ChooseZipcode.vue?vue&type=template&id=1b1f4ab6"
import script from "./ChooseZipcode.vue?vue&type=script&lang=js"
export * from "./ChooseZipcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports